import React from 'react';
import { Tag } from '@zillow/constellation-10';
import { Text } from '@zg-rentals/multibrand-ui/lib';
import ProblemTriangleFill from '@zg-rentals/multibrand-ui/lib/icons/ProblemTriangleFill';
import DetailsCard from '@rental-manager/components/DetailsCard';
import StringConstants from '@common/constants/StringConstants';
import {
  ACTIVE,
  CANCELLED,
  COVERAGE_REQUEST_SIGNED,
  PENDING_ACTIVATION,
  PENDING_CANCELLATION,
} from '@rental-manager/constants/RentalProtectionPolicyStatusConstants';

interface RentalProtectionProps {
  rentTerms: Record<string, any>;
  isLatestRentPaymentFailed: boolean;
  shouldDisplayRentalProtectionFirstRentFailedBanner: boolean;
  listingAlias: string;
  isCurrentTerm: boolean;
}

class RentalProtection extends React.Component<RentalProtectionProps> {
  viewRentalProtection = (policyId) => {
    const managePolicyUrl = StringConstants.LINKS.RENTAL_PROTECTION.MANAGE_POLICY_PAGE(
      this.props.listingAlias,
      policyId,
    );
    window.open(managePolicyUrl);
  };

  getRentalProtectionBadge = (policyStatus) => {
    switch (policyStatus) {
      case ACTIVE:
        return (
          <Tag className="fs-exclude" tone="green">
            Active
          </Tag>
        );
      case PENDING_ACTIVATION:
        return (
          <Tag className="fs-exclude" tone="gray">
            Pending activation
          </Tag>
        );
      case COVERAGE_REQUEST_SIGNED:
        return (
          <Tag className="fs-exclude" tone="gray">
            Request sent
          </Tag>
        );
      case PENDING_CANCELLATION:
        return (
          <Tag className="fs-exclude" tone="gray">
            Cancel request sent
          </Tag>
        );
      case CANCELLED:
        return (
          <Tag className="fs-exclude" tone="gray">
            Canceled
          </Tag>
        );
      default:
        return <></>;
    }
  };

  render(): React.ReactNode {
    const { rentTerms, isLatestRentPaymentFailed, shouldDisplayRentalProtectionFirstRentFailedBanner, isCurrentTerm } =
      this.props;
    const { rentalProtectionPolicy } = rentTerms;
    const { policyStatus, coverageRequestSigned, policyId } = rentalProtectionPolicy;

    return (
      <>
        <DetailsCard
          className="fs-exclude"
          title="Rental Protection"
          showEdit
          buttonTitle={'View'}
          onEdit={() => this.viewRentalProtection(policyId)}
        >
          <Text type="body-tiny">offered through Zillow Insurance Services</Text>
        </DetailsCard>
        <Text className="mts fs-exclude">
          {isCurrentTerm &&
            (!coverageRequestSigned ||
              isLatestRentPaymentFailed ||
              shouldDisplayRentalProtectionFirstRentFailedBanner) && (
              <Text>
                <ProblemTriangleFill colorType="warning" size="md" />
                <Text inline className="mls RentalProtection-warning fs-exclude">
                  {!coverageRequestSigned ? 'Coverage request not signed' : "The premium can't be processed"}
                </Text>
              </Text>
            )}
          {!isCurrentTerm && !coverageRequestSigned && (
            <Text>
              <ProblemTriangleFill colorType="warning" size="md" />
              <Text inline className="mls RentalProtection-warning fs-exclude">
                Coverage request not signed
              </Text>
            </Text>
          )}
          {coverageRequestSigned &&
            !isLatestRentPaymentFailed &&
            !shouldDisplayRentalProtectionFirstRentFailedBanner &&
            this.getRentalProtectionBadge(policyStatus)}
        </Text>
      </>
    );
  }
}

export default RentalProtection;
